import { cloneDeep } from "lodash";
import { allBudgetTypesOptions, allClassificationTypesOptions, allDataSourcesOptions, allMeasureUnitsOptions, allMutuallyRedeemingLevelOptions, allStatusOptions, allPeriodicitiesOptions, allReportNamesOptions, allReportTypesOptions, allDevelopTypesOptions } from "../../common/baseOptions";
import { Classificator } from "../../common/types/Classificator";
import { Template } from "../../common/types/Template";
import { ReportMBSPFilterSettings } from "./settings/ReportMBSPFilterSettings";
import { ReportMBSPFilterOptions } from "./options/ReportMBSPFilterOptions";
import { Indicator } from "../../common/types/Indicator";
import { Option } from "../../common/types/Option";
import { ByForm, StatusType } from "../../common/types/roots/fields";

export const reportMBSPIncomeClassificators: Classificator[] = [
    { key: 'kat', active: true, selected: [] },
    { key: 'cls', active: true, selected: [] },
    { key: 'pcl', active: true, selected: [] },
    { key: 'spf', active: true, selected: [] }
]
export const reportMBSPExpenseClassificators: Classificator[] = [
    { key: 'abp', active: true, selected: [] },
    { key: 'prg', active: true, selected: [] },
    { key: 'ppr', active: true, selected: [] },
    { key: 'spf', active: true, selected: [] },
]
export const reportMBSPIndicators: Indicator[] = [
    { key: 'sum_utv_plan', active: true },
    { key: 'sum_utoch_ref', active: true },
    { key: 'sum_scor_refs', active: true },
    { key: 'sum_plan', active: true },
    { key: 'sumrg', active: true },
    { key: 'january', active: true },
    { key: 'february', active: true },
    { key: 'march', active: true },
    { key: 'april', active: true },
    { key: 'may', active: true },
    { key: 'june', active: true },
    { key: 'july', active: true },
    { key: 'august', active: true },
    { key: 'september', active: true },
    { key: 'october', active: true },
    { key: 'november', active: true },
    { key: 'december', active: true },
]
const baseIndicators: Indicator[] = cloneDeep(reportMBSPIndicators.slice(0, 5))

export const reportMBSPStatusOptions: Option<StatusType>[] = allStatusOptions
export const MBSPByFormOptions: Option<ByForm>[] = [
    { value: '2-19', label: '2-19' },
    { value: '4-20', label: '4-20' }
]

// Нужна как временная затычка (При созданий нового берутся пустые настройки)
const tempSettings: ReportMBSPFilterSettings = {
    // Base:
    reportName: 'MBSP',
    reportType: 'REGULATED',
    classificationType: 'MIXED',
    dataSource: 'IISK',
    periodicity: 'DAY',
    // Custom:
    date: '',
    budgetTypes: [],
    regions: [],
    statuses: [],
    byForms: ['2-19', '4-20'],
    measureUnit: 'THOUSAND',
    roundUpTo: null,
    mutuallyRedeemingLevels: [],
    incomes: [],
    expenses: [],
    indicators: baseIndicators,
    highLevelExpenses: false,
    planByMonths: false
}

export const reportMBSPBaseTemplate: Template = {
    id: null,
    name: 'Взаимопогашаемые платежи местных бюджетов',
    excelName: null,
    description: null,
    category: '90',
    regions: [],
    userId: '',
    filterSettings: tempSettings
}

export const reportMBSPFilterOptions: ReportMBSPFilterOptions = {
    // Base:
    key: 'MBSP',
    reportNames: cloneDeep(allReportNamesOptions),
    reportTypes: cloneDeep(allReportTypesOptions),
    classificationTypes: cloneDeep(allClassificationTypesOptions.filter(it => it.value === 'MIXED')),
    dataSources: cloneDeep(allDataSourcesOptions.filter(it => it.value !== 'MIXED')),
    periodicities: cloneDeep(allPeriodicitiesOptions),
    // Custom:
    measureUnits: cloneDeep(allMeasureUnitsOptions),
    budgetTypes: cloneDeep(allBudgetTypesOptions).filter(it => it.value !== 1),
    regions: [], // Загружается с бэка
    mutuallyRedeemingLevels: cloneDeep(allMutuallyRedeemingLevelOptions),
    statuses: cloneDeep(reportMBSPStatusOptions),
    byForms: cloneDeep(MBSPByFormOptions),
    incomes: cloneDeep(reportMBSPIncomeClassificators),
    expenses: cloneDeep(reportMBSPExpenseClassificators),
    indicators: cloneDeep(reportMBSPIndicators),
    developTypes: cloneDeep(allDevelopTypesOptions),
}
